function removeMoneyMask(moneyString) {
  const cleanedString = moneyString.replace(/[^\d]/g, "");

  const amount = parseFloat(cleanedString);

  return amount;
}

export default removeMoneyMask;
